/**
 * External Dependencies
 */
import anchorme from 'anchorme';
import 'bootstrap';
import ClipboardJS from 'clipboard';
import 'core-js/stable';
import 'jquery';
import 'regenerator-runtime/runtime';

import AnchorLinks from './anchor-links';
import AutoComplete from './autocomplete';
import BlockQuickNavigation from './block-quick-navigation';
import ClickOutside from './click-outside';
import D3Sweden from './d3sweden';
import EditorJs from './editorJs';
import FaqBox from './faq-box';
import GoogleMap from './google-maps';
import Modal from './modal';
import Social from './social';
import SwipeableContainer from './swipeable-container';
import TaxonomyNavigation from './taxonomy-navigation';
import TextDescriptions from './text-descriptions';
import Tooltip from './tooltip';
import UserChannelPostCard from './user-channel-post-card';
import UserEditChannels from './user-edit-channels';
import UserList from './user-list';

$(document).ready(() => {
  $('html').removeClass('no-js');

  new AnchorLinks().init('.user-list__navigation-items');
  new AnchorLinks().init('.table-of-contents');
  new BlockQuickNavigation().init();
  new AutoComplete().init();
  new ClipboardJS('.post-social__button--copy');
  new D3Sweden().init();
  new EditorJs().init('#user-social-post-new');
  new FaqBox().init();
  new GoogleMap().init();
  new Modal().init();
  new Social().init();
  new SwipeableContainer().init('.list-latest-posts .container-swipeable--mobile');
  new SwipeableContainer().init('#modal--site-shortcuts .container-swipeable--mobile', {
    loop: false,
  });
  new TaxonomyNavigation().init();
  new TextDescriptions().init();
  new Tooltip().init('.nottooltipped');
  new UserChannelPostCard().init();
  new UserEditChannels().init();
  new UserList().init();

  const domain = window.location.hostname;

  // Open external links in new tab
  $('a').on('click', event => {
    const self = $(event.currentTarget);

    if (self !== undefined && self.length > 0) {
      const link = self[0];

      if (link && link.href && link.href.indexOf(domain) === -1 && link.target == '') {
        event.preventDefault();
        window.open(link.href, '_blank');
      }
    }
  });

  // User navigation
  const userNavigationSection = $('#site-header-user-menu-main-section');
  const userNavigationSavedPages = $('#site-header-user-menu-saved-pages-section');

  $('#site-header-user-menu-toggle').on('click', event => {
    const self = $(event.currentTarget);
    const menu = self.siblings('.site-header-user-menu');

    const isOpen = menu.is(':visible');

    const openMenu = () => {
      menu.removeClass('d-none');
    };

    const closeMenu = () => {
      menu.addClass('d-none');
      userNavigationSavedPages.addClass('d-none');
      userNavigationSection.removeClass('d-none');
    }

    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
      new ClickOutside().init('#site-header-user-menu-toggle + .site-header-user-menu', closeMenu);
    }
  });

  userNavigationSection.on('click', '#site-header-user-menu-saved-pages-toggle', () => {
    userNavigationSection.addClass('d-none');
    userNavigationSavedPages.removeClass('d-none');
  });

  userNavigationSavedPages.on('click', '#site-header-user-menu-saved-pages-header', () => {
    userNavigationSavedPages.addClass('d-none');
    userNavigationSection.removeClass('d-none');
  });

  // User notifications
  $('#site-header-user-notifications-toggle').on('click', '.site-header__link', event => {
    const self = $(event.currentTarget);
    const form = self.parents('form');
    const menu = form.siblings('.site-header-user-menu');

    const isOpen = menu.is(':visible');

    const openMenu = () => {
      form.siblings('.site-header__item-counter').addClass('d-none');
      menu.removeClass('d-none');
    };

    const closeMenu = () => {
      menu.addClass('d-none');
    };

    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
      new ClickOutside().init('#site-header-user-notifications-toggle + .site-header-user-menu', closeMenu);
    }
  });

  // Preview upload image
  $('input#acf-field_5ffa687a6c42d, input#acf-field_6005dc5083b96, #customFile')
    .on('change', event => {
      const reader = new FileReader();
      reader.onload = () => {
        const output = document.getElementById('output_image');
        output.src = reader.result;

        const image_holder = $('#output_image');
        image_holder.parents('.d-none').removeClass('d-none');
      }
      reader.readAsDataURL(event.target.files[0]);
    });

  // User social post anchors
  // Auto link urls in text

  const anchorMe = () => {
    $('.user-social-post-card .post-card__content').each((i, elm) => {
      const self = $(elm);
      const input = self.html();

      self.html(anchorme({
        input,
        options: {
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      }));
    });
  };
  anchorMe();

  // Comment delete
  document.body.addEventListener('commentDelete', function(evt) {
    const comment_id = evt.detail.value;
    const comment = $(`#comment-${comment_id}`);
    if (comment.length) {
      comment.fadeOut(300, () => {
        comment.remove();
      });
    }
  });

  document.body.addEventListener('updateClipboard', function() {
    setTimeout(() => {
      new Tooltip().init('.nottooltipped');
    }, 1000);
  });

  document.body.addEventListener('anchorMe', function() {
    setTimeout(() => {
      anchorMe();
    }, 1000);
  });
});
